import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChairModern: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="chair-modern, seat"><path d="M18.75 14.25L16.1538 2.75H7.84615L5.25 14.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M20.25 14C14.0625 15.6667 9.9375 15.6667 3.75 14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M8 15.25L6 21.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M16 15.25L18 21.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconChairModern;
